<template>
  <header class="main-header">
    <router-link to="/" class="logo">Oshewon fabrics</router-link>

    <nav class="main-nav" :class="{ 'nav-open': isNavOpen }">
      <router-link to="/products?category=mattresses">Mattresses</router-link>
      <router-link to="/products?category=pillows">Pillows</router-link>
      <router-link to="/products?category=bedding">Bedding</router-link>
      <router-link to="/products?category=bases">Bases</router-link>
      <router-link to="/products?category=bundles">Bundles</router-link>
    </nav>

    <div class="header-actions">
      <a href="#" @click.prevent="showSearch">Search</a>
      <router-link v-if="!isAuthenticated" to="/login">Sign In</router-link>
      <a v-else href="#" @click.prevent="logout">Sign Out</a>

      <div class="cart-icon" @click="goToCheckout">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
          />
        </svg>
        <span class="cart-count">{{ cartCount }}</span>
      </div>

      <button
        class="hamburger-menu"
        :class="{ active: isNavOpen }"
        @click="toggleNav"
        aria-label="Toggle menu"
      >
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>
    </div>
  </header>
</template>

<script>
import { useCartStore } from "../stores/cart";
import { useAuthStore } from "../stores/auth";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "Header",
  setup() {
    const cartStore = useCartStore();
    const authStore = useAuthStore();
    const router = useRouter();

    const cartCount = computed(() => cartStore.cartCount);
    const isAuthenticated = computed(() => authStore.isAuthenticated);
    const isNavOpen = ref(false);

    const toggleNav = () => {
      isNavOpen.value = !isNavOpen.value;
    };

    const goToCheckout = () => {
      if (cartStore.cartCount > 0) {
        router.push("/checkout");
      } else {
        alert("Your cart is empty!");
      }
    };

    const showSearch = () => {
      // TODO: Implement search functionality
      alert("Search functionality coming soon!");
    };

    const logout = () => {
      authStore.logout();
      router.push("/");
    };

    return {
      cartCount,
      isNavOpen,
      isAuthenticated,
      toggleNav,
      goToCheckout,
      showSearch,
      logout,
    };
  },
};
</script>
